var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0088 10.7169H24.9627V10.6627H13.2627V15.8627H20.609C19.5393 18.8893 16.6583 21.0627 13.2627 21.0627C8.95645 21.0627 5.4627 17.5689 5.4627 13.2627C5.4627 8.95645 8.95645 5.4627 13.2627 5.4627C15.2499 5.4627 17.0611 6.21426 18.439 7.43639L22.1156 3.75983C19.7932 1.59655 16.6854 0.262695 13.2627 0.262695C6.08223 0.262695 0.262695 6.08223 0.262695 13.2627C0.262695 20.4432 6.08223 26.2627 13.2627 26.2627C20.4432 26.2627 26.2627 20.4432 26.2627 13.2627C26.2627 12.3926 26.1747 11.5395 26.0088 10.7169Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2627 7.15658L5.45764 10.2627C6.59536 7.42522 9.34653 5.42052 12.5634 5.42052C14.5162 5.42052 16.296 6.16599 17.6499 7.37821L21.2627 3.73147C18.9806 1.58573 15.9267 0.262695 12.5634 0.262695C7.65657 0.262695 3.40175 3.05988 1.2627 7.15658Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6708 26.2627C15.9807 26.2627 18.9871 25.0217 21.2627 23.0067L17.2954 19.7212C16.0108 20.6748 14.4092 21.2464 12.6708 21.2464C9.33744 21.2464 6.50794 19.166 5.44354 16.2627L1.2627 19.4142C3.38482 23.4769 7.69246 26.2627 12.6708 26.2627Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0088 10.3158H24.9627V10.2627H13.2627V15.3614H20.609C20.0945 16.7888 19.1601 18.017 17.9515 18.9132C17.9549 18.9099 17.9549 18.9099 17.9549 18.9099L21.9801 22.2493C21.6924 22.5016 26.2627 19.1854 26.2627 12.812C26.2627 11.9589 26.1747 11.1224 26.0088 10.3158Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.3bfb01969476f86feb563f00f39d5c0f.svg";
export { ForwardRef as ReactComponent };